(function () {
  // ---------- helpers ----------
  function findUrlInElement(el) {
    if (!el) return '';
    var text = (el.innerText || el.textContent || '').trim();
    // picks first URL in the modal/popup content
    var m = text.match(/https?:\/\/[^\s"']+/i);
    return m ? m[0] : '';
  }

  function setBtnState(btn, label) {
    if (!btn) return;
    var old = btn.textContent;
    btn.textContent = label;
    setTimeout(function () { btn.textContent = old; }, 1200);
  }

  function fallbackCopy(value) {
    var ta = document.createElement('textarea');
    ta.value = value;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    ta.style.top = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, ta.value.length); // iOS/Safari
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  function copyText(value, btn) {
    if (!value) {
      setBtnState(btn, 'Kein Link');
      return;
    }

    // Clipboard API (best) + fallback (Safari/blocked contexts)
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
      navigator.clipboard.writeText(value)
        .then(function () { setBtnState(btn, 'Kopiert'); })
        .catch(function () {
          var ok = fallbackCopy(value);
          setBtnState(btn, ok ? 'Kopiert' : 'Nicht möglich');
        });
    } else {
      var ok2 = fallbackCopy(value);
      setBtnState(btn, ok2 ? 'Kopiert' : 'Nicht möglich');
    }
  }

  // ---------- your original block (kept) ----------
  var root = document.querySelector('[data-van-leftpromo]');
  if (root) {
    var tab = root.querySelector('.van-leftpromo__tab');
    var modal = root.querySelector('.van-leftpromo__modal');
    var overlay = root.querySelector('.van-leftpromo__overlay');
    var closers = root.querySelectorAll('[data-van-leftpromo-close]');
    var copyBtn = root.querySelector('[data-van-leftpromo-copy]');

    function openModal() {
      root.classList.add('is-open');
      if (overlay) overlay.hidden = false;
      if (modal) modal.hidden = false;
      tab && tab.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('van-leftpromo-lock');
      document.body.classList.add('van-leftpromo-lock');
    }

    function closeModal() {
      root.classList.remove('is-open');
      if (overlay) overlay.hidden = true;
      if (modal) modal.hidden = true;
      tab && tab.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('van-leftpromo-lock');
      document.body.classList.remove('van-leftpromo-lock');
    }

    tab && tab.addEventListener('click', openModal);
    closers.forEach(function (el) { el.addEventListener('click', closeModal); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // read fresh at click time
        var target = root.querySelector('.van-leftpromo__copyinput');
        var text = (target && target.value && target.value.trim()) ? target.value.trim() : '';

        if (!text) {
          var linkTplNow = root.querySelector('[data-van-leftpromo-link]');
          text = linkTplNow ? (linkTplNow.textContent || '').trim() : '';
        }

        copyText(text, copyBtn);
      });
    }

    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('customer_posted') === 'true') openModal();
    } catch (e) {}
  }

  // ---------- IMPORTANT FIX: make copy work for the Loox popup too ----------
  // This catches dynamically injected "Kopieren" buttons and copies the URL shown in that popup.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest
      ? e.target.closest('button, a, [role="button"]')
      : null;
    if (!btn) return;

    // Match your custom copy button OR any button that says "Kopieren"
    var isOurBtn = btn.matches && btn.matches('[data-van-leftpromo-copy]');
    var isKopieren = (btn.textContent || '').trim().toLowerCase() === 'kopieren';

    if (!isOurBtn && !isKopieren) return;

    // Stop default if it’s a button inside form etc.
    e.preventDefault();
    e.stopPropagation();

    // First: try input value near the button
    var scope =
      btn.closest('.van-leftpromo__modal') ||
      btn.closest('[role="dialog"]') ||
      btn.closest('.modal') ||
      btn.closest('div');

    var input = scope ? scope.querySelector('input[type="text"], input[type="url"], textarea') : null;
    var value = (input && input.value && input.value.trim()) ? input.value.trim() : '';

    // If no input value: scan popup text for a URL (works for Loox-style popups)
    if (!value) value = findUrlInElement(scope);

    copyText(value, btn);
  }, true);
})();
